import { RedirectButton } from '@y42/gojs';
import { Binding } from 'gojs';
import {
  DataLineageNodeBinding,
  DataLineageUINode,
  LINEAGE_PARTS,
} from '../../../../../../../state/data-lineage-diagram';
import { buttonToolTip } from './tooltip';

const isRedirectEnabledBinding = () =>
  new Binding('isEnabled', '', (node: DataLineageUINode) => node[DataLineageNodeBinding.HasReadPermission]);

export const lineageRedirectButton = (bindings: Binding[] = []) =>
  RedirectButton({
    partName: LINEAGE_PARTS.OVERVIEW_BUTTON,
    bindings: [isRedirectEnabledBinding(), ...bindings],
    toolTip: buttonToolTip('Redirect To', 'You do not have read access to this asset'),
  });
